import {
  DiscoverTopicSection,
  SearchIcon,
  SearchSection,
  SearchTitle,
  SearchTopics,
} from './styled';
import { getScreenName } from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';

export default function DiscoverTopics(props) {
  const { setSearchString } = props;
  const fireEventHandler = () => {
    fireEvent({
      category: 'clicked_search_bar',
      screen_name: getScreenName(),
      page_url: window.location.href,
      parent: 'topic_search_bar',
    });
  };
  return (
    <DiscoverTopicSection>
      <SearchTitle>Discover Topics</SearchTitle>

      <SearchSection>
        <SearchIcon src="/images/searchblacknew.svg" alt="" />
        <SearchTopics
          type="text"
          placeholder="Search for topics here..."
          onChange={(e) => setSearchString(e.target.value)}
          onClick={fireEventHandler}
          id={'topicSearch'}
        />
      </SearchSection>
    </DiscoverTopicSection>
  );
}
